/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input } from '@angular/core';
import { IAmiHead } from './ami-head.interface';

@Component({
  selector: 'ami-head',
  templateUrl: './ami-head.component.html'
})
export class AmiHeadComponent {
  @Input() settings: IAmiHead;
}
